<template>
  <b-row v-if="columns">
    <app-column
      v-for="column in columns"
      :key="column.index"
      :content="column.content"
      :sm-cols="column.smCols"
      :md-cols="column.mdCols"
    />
  </b-row>
</template>

<script>

import AppColumn from '@/components/blocks/AppColumn'

export default {
  name      : 'AppRow',
  components: { AppColumn },
  props     : { columns: { type: Array, default: null } },
}
</script>
